module.exports = __webpack_public_path__ + "static/media/HalfElf.c0ddf1b7.png";